import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Tabs from './Tabs';
import { IMG_DEFAULT, MyIcon } from '../../common/baseConfig';
import { List } from 'antd';
import { Link } from 'react-router-dom';
import shallowequal from 'shallowequal';
import NoneData from "../common/NoneData";
export class CoursePackList extends Component {
  state = {
    DisciplineID: 0,
    secondIndex: 0,
    thirdIndex: 0,
    secondList: [],
    thirdList: [],
    curPage: 1,
  }
  static propTypes = {
    course: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    let pathname = this.props.history.location.pathname;
    let pathArr = pathname.substring(pathname.lastIndexOf('/') + 1, pathname.length).split('-');
    this.setState(
      {
        DisciplineID: parseInt(pathArr[0], 10),
        secondIndex: parseInt(pathArr[1], 10),
        thirdIndex: parseInt(pathArr[2], 10),
      },
      () => {
        this.onLoadCourseList();
      },
    );
  }
  componentDidMount() {
    //获取课程包分类列表需要传Type:1
    this.props.actions.fetchGetAllDisciplineInfo({ Type: 1 });
  }
  componentDidUpdate(preProps, preState) {
    const { DisciplineID, secondIndex, thirdIndex } = this.state;
    if (!shallowequal(preState, this.state)) {
      //state前后无变化无需更新否则堆栈溢出
      this.onLoadCourseList();
      this.updatetRouter([DisciplineID, secondIndex, thirdIndex]);
    }
  }
  updatetRouter(pathArr) {
    //更新路由记录
    this.props.history.replace(
      `/coursepacklist/${pathArr[0]}-${pathArr[1]}-${pathArr[2]}`,
    );
  }
  getDisciplineID() {
    const { DisciplineID, secondIndex, thirdIndex } = this.state;
    let discipline_ID = 0;
    if (thirdIndex === 0) {
      discipline_ID = secondIndex;
      if (secondIndex === 0) {
        discipline_ID = DisciplineID;
        if (DisciplineID === 0) {
          discipline_ID = 0;
        }
      }
    } else {
      discipline_ID = thirdIndex;
    }
    return { Discipline_ID: discipline_ID, TeachingMethod: 0 };
  }
  onLoadCourseList() {
    let obj = this.getDisciplineID();
    this.props.actions.fetchGetStuCoursePackList({
      PageSize: 12,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      ...obj,
    });
  }
  //一级分类切换
  onTabsChange(DisciplineID) {
    const { fetchGetAllSecondListByIDs } = this.props.course;
    if (DisciplineID === 0) {
      this.setState({
        DisciplineID: DisciplineID,
        secondIndex: 0,
        thirdIndex: 0,
        secondList: [],
        thirdList: [],
        curPage: 1,
      });
    } else {
      this.setState({
        DisciplineID: DisciplineID,
        secondIndex: 0,
        thirdIndex: 0,
        secondList: fetchGetAllSecondListByIDs[DisciplineID],
        thirdList: [],
        curPage: 1,
      });
    }
  }
  //二级分类切换
  onSecondChange(key) {
    const { fetchGetAllThirdListByIDs } = this.props.course;
    if (key === 0) {
      this.setState({
        secondIndex: key,
        thirdIndex: 0,
        thirdList: [],
        curPage: 1,
      });
    } else {
      this.setState({
        secondIndex: key,
        thirdIndex: 0,
        thirdList: fetchGetAllThirdListByIDs[key],
        curPage: 1,
      });
    }
  }
  //三级分类切换
  onThirdChange(key) {
    this.setState({
      thirdIndex: key,
      curPage: 1,
    });
  }
  renderItem(item) {
    return (
      <Link key={item.ID} className="coursePackList-inner-item" to={`/coursepack/detail/${item.ID}`}>
        <img src={item.CoverPath || IMG_DEFAULT} alt="" />
        <h2>
          {item.Name}
        </h2>
        <p>
          <span>
            {item.PreferentialPrice === 0 ? '免费' : '¥' + item.PreferentialPrice.toFixed(2)}{' '}
            {item.IsShiT > 0 ? '可试学' : ''}
          </span>
          <span>
            <MyIcon type="iconrenshu" /> {item.BuyBase + (item.BuyCount || 0)}
          </span>
        </p>
      </Link>
    );
  }
  render() {
    let {
      DisciplineID,
      secondIndex,
      thirdIndex,
      secondList,
      thirdList,
      curPage,
    } = this.state;
    let {
      fetchGetAllDisciplineInfoSuccess,
      fetchGetAllSecondListByIDs,
      fetchGetAllThirdListByIDs,
      fetchGetStuCoursePackListSuccess,
      fetchGetStuCoursePackListPending,
      fetchGetStuCoursePackListTotal,
    } = this.props.course;
    if (!fetchGetAllDisciplineInfoSuccess) return null;
    if (DisciplineID !== 0 && fetchGetAllSecondListByIDs) {
      secondList = fetchGetAllSecondListByIDs[DisciplineID];
    }
    if (secondIndex !== 0 && fetchGetAllThirdListByIDs) {
      thirdList = fetchGetAllThirdListByIDs[secondIndex];
    }
    return (
      <div className="course-course-pack-list">
        <div className="banner">
          <h1>课程包</h1>
        </div>
        <div className="tabs">
          <Tabs
            {...this.props}
            cancelMatchRouter={true}
            tabs={fetchGetAllDisciplineInfoSuccess}
            onTabsChange={this.onTabsChange.bind(this)}
          />
        </div>
        {secondList.length !== 0 && (
          <div className="subject">
            <p>二级学科:</p>
            <ul>
              {secondList.map(item => (
                <li
                  key={item.ID}
                  className={`radio${secondIndex === item.ID ? ' active-radio' : ''}`}
                  onClick={this.onSecondChange.bind(this, item.ID)}
                >
                  {item.Name}
                </li>
              ))}
            </ul>
          </div>
        )}
        {thirdList.length !== 0 && (
          <div className="subject">
            <p>三级学科:</p>
            <ul>
              {thirdList.map(item => (
                <li
                  key={item.ID}
                  className={`radio${thirdIndex === item.ID ? ' active-radio' : ''}`}
                  onClick={this.onThirdChange.bind(this, item.ID)}
                >
                  {item.Name}
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="coursePackList">
          {fetchGetStuCoursePackListSuccess && fetchGetStuCoursePackListSuccess.length > 0 ? (
            <div className="coursePackList-inner">
              <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState(
                      {
                        curPage: page,
                      },
                      () => {
                        this.onLoadCourseList();
                      },
                    );
                  },
                  current: curPage,
                  total: fetchGetStuCoursePackListTotal,
                  pageSize: 12,
                }}
                loading={fetchGetStuCoursePackListPending}
                dataSource={fetchGetStuCoursePackListSuccess}
                renderItem={item => this.renderItem(item)}
              />
            </div>
          ) : (
              <div className="noneData">
                <NoneData type={1} />
              </div>
            )}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    course: state.course,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoursePackList);



// WEBPACK FOOTER //
// ./src/features/course/CoursePackList.js